const state = {
  filtros: {
    grupos: [],
    fora_de_linha: true,
    inativo_revenda: true,
    produto_resgatado: true,
    venda_futura_maior_que_saldo_estoque: true,
    primeira_entrada: [2, 3],
    ultima_entrada: [1, 2, 3],
    idade: [2, 3],
    tipos_produtos: ['PRODUTOS_NAO_COMBINADOS', 'PRODUTOS_COMBINADOS'],
    compradores: [],
    segmentos: [],
    fornecedores: [],
    secoes: [],
    categorias: [],
    status_produto: [],
    linhas: [],
    pedidos_pendentes: [],
    produtos_mix_filial: [2],
    histogramas: [],
    produtos: [],
    marcas: [],
  }
}

const getters = {
  filtros(state) {
    return state.filtros
  },
  filtros_formato_api({ filtros }) {
    return {
      ...filtros,
      fora_de_linha: filtros.fora_de_linha ? 'S' : 'N',
      inativo_revenda: filtros.inativo_revenda ? 'S' : 'N',
      produto_resgatado: filtros.produto_resgatado ? 'S' : 'N',
      venda_futura_maior_que_saldo_estoque: filtros.venda_futura_maior_que_saldo_estoque ? 'S' : 'N',
    }
  }
}

const mutations = {
  filtros(state, valor){
    state.filtros = valor;
  },
  filtrosGrupos(state, valor){
    state.filtros.grupos = valor;
  }
}

const actions = {
  filtros: ({ commit }, valor) => {
    commit("filtros", valor);
  },
  filtrosGrupos: ({ commit }, valor) => {
    commit("filtrosGrupos", valor);
  }
}

export default { namespaced: true, state, mutations, getters, actions }
